import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS

export const FETCH_REQUEST = 'collectorAddress/FETCH_REQUEST';
export const FETCH_SUCCESS = 'collectorAddress/FETCH_SUCCESS';
export const FETCH_ERROR = 'collectorAddress/FETCH_ERROR';

export const SINGLE_FETCH_REQUEST = 'collectorAddress/SINGLE_FETCH_REQUEST';
export const SINGLE_FETCH_SUCCESS = 'collectorAddress/SINGLE_FETCH_SUCCESS';
export const SINGLE_FETCH_ERROR = 'collectorAddress/SINGLE_FETCH_ERROR';

export const UNLOAD_CURRENT = 'collectorAddress/UNLOAD_CURRENT';

export const CREATE_REQUEST = 'collectorAddress/CREATE_REQUEST';
export const CREATE_SUCCESS = 'collectorAddress/CREATE_SUCCESS';
export const CREATE_ERROR = 'collectorAddress/CREATE_ERROR';

export const DELETE_REQUEST = 'collectorAddress/DELETE_REQUEST';
export const DELETE_SUCCESS = 'collectorAddress/DELETE_SUCCESS';
export const DELETE_ERROR = 'collectorAddress/DELETE_ERROR';

export const MODIFY_REQUEST = 'collectorAddress/MODIFY_REQUEST';
export const MODIFY_SUCCESS = 'collectorAddress/MODIFY_SUCCESS';
export const MODIFY_ERROR = 'collectorAddress/MODIFY_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case FETCH_REQUEST:
    case SINGLE_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: false,
        entities: action.payload.entities.collectorAddress,
        result: action.payload.result,
      };

    case SINGLE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        current: action.payload,
      };

    case MODIFY_SUCCESS:
      return {
        ...state,
        entities: { ...state.entities, [action.payload.id]: action.payload },
      };

    case FETCH_ERROR:
    case SINGLE_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };

    case UNLOAD_CURRENT:
      return {
        ...state,
        current: null,
      };
    default:
      return state;
  }
}

// Schemas

const collectorSchema = new schema.Entity('collectorAddress');

// Operations

export function fetchCollectorAddresses(collectorId) {
  return {
    [CALL_API]: {
      types: [FETCH_REQUEST, FETCH_SUCCESS, FETCH_ERROR],
      promise: (httpClient) =>
        httpClient.post(
          '/collectorAddress',
          collectorId
            ? {
                filter: {
                  filters: [
                    {
                      field: 'collector___id',
                      value: Number(collectorId),
                      operator: 'eq',
                    },
                  ],
                  logic: 'and',
                },
              }
            : {}
        ),
      schema: { data: [collectorSchema] },
    },
  };
}

export function fetchCollectorAddress(id) {
  return function (dispatch, getState) {
    const collectorAddressState = getState().collectorAddress;

    if (
      collectorAddressState.entities &&
      id in collectorAddressState.entities
    ) {
      // collector already exists in store
      dispatch({
        type: SINGLE_FETCH_SUCCESS,
        payload: collectorAddressState.entities[id],
      });
    } else {
      dispatch({
        [CALL_API]: {
          types: [
            SINGLE_FETCH_REQUEST,
            SINGLE_FETCH_SUCCESS,
            SINGLE_FETCH_ERROR,
          ],
          promise: (httpClient) => httpClient.get(`/collectorAddress/${id}`),
        },
      });
    }
  };
}

export function unloadCurrent() {
  return function (dispatch) {
    dispatch({ type: UNLOAD_CURRENT });
  };
}

export function modifyCollectorAddress({
  collectorAddress,
  onSuccess,
  successMessage,
  errorMessage,
}) {
  return {
    [CALL_API]: {
      types: [MODIFY_REQUEST, MODIFY_SUCCESS, MODIFY_ERROR],
      promise: (httpClient) =>
        httpClient.post('/collectorAddress/modify', collectorAddress),
      successMessage:
        successMessage || 'Collector address successfully modified',
      errorMessage: errorMessage || 'There was a problem updating the address',
      onSuccess,
    },
  };
}

export function createCollectorAddress(collector) {
  return {
    [CALL_API]: {
      types: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_ERROR],
      promise: (httpClient) =>
        httpClient.post('/collectorAddress/modify', collector),
      successMessage: 'CollectorAddress successfully created',
    },
  };
}

export function deleteCollectorAddress({
  id,
  successMessage,
  errorMessage,
  onSuccess,
}) {
  return {
    [CALL_API]: {
      types: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_ERROR],
      promise: (httpClient) =>
        httpClient.delete(`/collectorAddress/${id}/delete`),
      successMessage: successMessage || 'CollectorAddress successfully deleted',
      errorMessage:
        errorMessage || 'There was a problem deleting the collector',
      onSuccess: onSuccess || (() => null),
    },
  };
}
